import React from "react";
import { Text } from "react-native";
import { colors, global } from "../../const";

export default function PrimaryTitle({ children, size, color, align, weight, ...other }) {
    return (
        <Text
            style={{
                fontFamily: global.FONT_REGULAR,
                fontSize: size || 18,
                color: color || colors.midnightBack,
                textAlign: align || "left",
                fontWeight: weight || "400"
            }}
            {...other}
        >
            {children}
        </Text>
    )
}